/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import UploadCoverImageComponent from './components/pages/ImageIngestion/UploadCoverImageComponent';
import UploadCoverImageMetadataComponent from './components/pages/ImageIngestion/UploadCoverImageMetadataComponent';
import UploadCoverImageTemplateDetailsComponent from './components/pages/ImageIngestion/UploadCoverImageTemplateDetailsComponent';
import CoverImageTemplateStatus from './components/pages/ImageIngestion/CoverImageTemplateStatus';
import CoverImageMetadataStatus from './components/pages/ImageIngestion/CoverImageMetadataStatus';
import CoverImageStatus from './components/pages/ImageIngestion/CoverImageStatus';
import AccountsComponent from "./components/pages/Accounts/AccountsComponent";
import HomePage from './components/pages/HomePage/HomePage';
import CollectionList from "./components/pages/SaleRepCapabilities/collectionList";
import SaleRepHomePage from "./components/pages/HomePage/SaleRepHomePage";

const Routes = () => (<Switch>
    <Route path="/" exact component={HomePage}/>
    <Route path="/cover-image-upload" component={UploadCoverImageComponent} />
    <Route path="/cover-image-metadata-upload" component={UploadCoverImageMetadataComponent} />
    <Route path="/cover-image-template-detail-upload" component={UploadCoverImageTemplateDetailsComponent} />
    <Route path="/cover-template-status" component={CoverImageTemplateStatus} />
    <Route path="/cover-metadata-status" component={CoverImageMetadataStatus} />
    <Route path="/cover-status" component={CoverImageStatus} />
    <Route path="/assign-roles" component={AccountsComponent}/>
    <Route path="/collection-list" component={CollectionList}/>
    <Route path="/salesrep-search" component={SaleRepHomePage}/>
</Switch>);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js